// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.serve-position-manager {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.page-description {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* Tabs */
.tabs-container {
  margin-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
}

.tabs {
  display: flex;
  gap: 8px;
}

.tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: #6b7280;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  bottom: -2px;
}

.tab:hover {
  color: #1f2937;
  background-color: #f9fafb;
}

.tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  background-color: #eff6ff;
}

.tab-icon {
  font-size: 18px;
}

.tab-content {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .serve-position-manager {
    padding: 12px;
  }

  .page-title {
    font-size: 22px;
  }

  .tabs {
    flex-direction: column;
    gap: 0;
  }

  .tab {
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
    border-left: 3px solid transparent;
  }

  .tab.active {
    border-bottom: 1px solid #e5e7eb;
    border-left-color: #2563eb;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServePositions/ServePositionManager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;AACF","sourcesContent":[".serve-position-manager {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.page-description {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* Tabs */\n.tabs-container {\n  margin-bottom: 24px;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.tabs {\n  display: flex;\n  gap: 8px;\n}\n\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: #6b7280;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  bottom: -2px;\n}\n\n.tab:hover {\n  color: #1f2937;\n  background-color: #f9fafb;\n}\n\n.tab.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  background-color: #eff6ff;\n}\n\n.tab-icon {\n  font-size: 18px;\n}\n\n.tab-content {\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .serve-position-manager {\n    padding: 12px;\n  }\n\n  .page-title {\n    font-size: 22px;\n  }\n\n  .tabs {\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .tab {\n    padding: 12px 16px;\n    border-bottom: 1px solid #e5e7eb;\n    border-left: 3px solid transparent;\n  }\n\n  .tab.active {\n    border-bottom: 1px solid #e5e7eb;\n    border-left-color: #2563eb;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
